import tools from '@/sag-core/tools'
export default class StoreBase {

    constructor(serviceName){
        this.serviceName = serviceName    
        this.namespaced = true
        this.state = {
            pageGridDatas: [
            ],
            pageApiDatas: {
            },
            pageEvents: {}
        }

        tools.debug.log({tag: 'test', title: 'StoreBase檢查', content: 'StoreBase物件傳入的serviceName'}, this.serviceName)

        this.mutations = {
            mEventAdd(state, obj){
                if(obj.name in state.pageEvents){
                    if(!state.pageEvents[obj.name].find(e => e === obj.event)){
                        state.pageEvents[obj.name].push(obj.event)
                        tools.debug.log({tag: 'eventsStore',title: '全域事件註冊(疊加)', content: `event name: ${obj.name}`}, state.pageEvents, state)
                    }
                    else{
                        state.pageEvents[obj.name][state.pageEvents[obj.name].findIndex(e=>e === obj.event)] = obj.event
                        tools.debug.log({tag: 'eventsStore',title: '全域事件註冊(覆寫)', content: `event name: ${obj.name}`}, state.pageEvents, state)
                    }
                }
                else{
                    state.pageEvents[obj.name] = [obj.event]
                    tools.debug.log({tag: 'eventsStore', title: '全域事件註冊', content: `event name: ${obj.name}`}, state.pageEvents, state)
                }
            },
            mEventInvoke(state, obj){
                if(obj.name in state.pageEvents){
                    for(let i = 0; i < state.pageEvents[obj.name].length; i++){
                        state.pageEvents[obj.name][i](obj.args)
                    }
                    tools.debug.log({tag: 'eventsStore',title: '全域事件調用', content: `event name: ${obj.name}`}, state.pageEvents, state)
                }
                else{
                    tools.debug.log({tag: 'eventsStore',title: '全域事件找不到', content: `event name: ${obj.name}`}, state.pageEvents, state)
                }
            }
        }
        
        this.actions = {
            eventAdd(ctx, obj){
                ctx.commit('mEventAdd', obj)
            },
            eventInvoke(ctx, obj){
                ctx.commit('mEventInvoke', obj)
            }
        }
    }
    
}    
